import { render, staticRenderFns } from "./SalonBottomButton.vue?vue&type=template&id=96488b7c&scoped=true&"
import script from "./SalonBottomButton.vue?vue&type=script&lang=js&"
export * from "./SalonBottomButton.vue?vue&type=script&lang=js&"
import style0 from "./SalonBottomButton.vue?vue&type=style&index=0&id=96488b7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96488b7c",
  null
  
)

export default component.exports